module.exports = __webpack_public_path__ + "../resources/img/ic_download.2a6db2f9.svg";